import { render, staticRenderFns } from "./ArmsRegArchiveFilingInfo.vue?vue&type=template&id=ce8ea810&scoped=true&"
import script from "./ArmsRegArchiveFilingInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveFilingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8ea810",
  null
  
)

export default component.exports